import { type FC } from "react";

import { useDateFormat } from "../../hooks/useDateFormat";

import { TextContent } from "./TextContent";

interface LensUpdateAtDateProps {
    seconds: number;
    dataTestId?: string;
    className?: string;
}

export const LensUpdateAtDate: FC<LensUpdateAtDateProps> = ({ seconds, dataTestId, className }) => {
    const formattedDate = useDateFormat(seconds);
    return (
        <TextContent className={className} data-testid={dataTestId ?? "lens-update-date"}>
            {formattedDate}
        </TextContent>
    );
};
